/*
 * hero-video.js -- hero video detailu hry: JEDEN ZDROJ, JEDNO STAZENI.
 *
 * PROC TENHLE MODUL VZNIKL (mereni 8. 9. 2026)
 *
 * `game-hero-gallery.php` vypisuje hero video DVAKRAT: `.dgvideo`
 * (desktopovy filmstrip) a `.mgvideo` (mobilni swipe pas). Ktera z obou
 * variant je videt, rozhoduje media query -- `.mgal { display: none }`
 * a pod 767 px naopak `.gdet-gal { display: none }` (`components.css`).
 * `display: none` ale NEZASTAVI stahovani: `<video autoplay>` ve skryte
 * vetvi si soubor stahne a doburferuje uplne stejne jako ten viditelny.
 * Zmereno na DEV pred opravou: detail hry Praha stahl `th-praha-16x9-cz
 * .mp4` (34,9 MB) DVAKRAT -- 2 pozadavky, 69,7 MB na mobilu i na
 * desktopu; Mikulov dokonce 5 pozadavku a 105 MB. Skryty prvek koncil
 * s `readyState` 4, tedy kompletne nacteny.
 *
 * VZOR JE PREVZATY, NE VYMYSLENY. `hero.js` (08-07, KOMP-02) resi tentyz
 * problem na homepage a jeho komentar "JEDEN ELEMENT, JEDEN ZDROJ" popisuje
 * presne tuhle hrozbu: "Dva elementy vedle sebe by na mobilnim pripojeni
 * znamenaly dve soubezna stahovani MP4." Tady se ale oba elementy z DOM
 * odstranit NEDAJI -- mobilni navrh ma galerii jinde ve strome nez
 * desktopovy (`.mgal` ma `order: -1` uvnitr `.dhead .wrap`), takze jeden
 * sdileny uzel by musel skakat mezi dvema misty stromu pri kazde zmene
 * sirky. Drzi se proto slabsi, ale stejne ucinna varianta: oba uzly
 * v markupu ZUSTAVAJI, ale `src` dostane VZDY JEN TEN, ktery je pri
 * aktualni sirce skutecne videt. Druhy zustane bez `src`, tedy
 * `networkState` NETWORK_EMPTY -- prohlizec o zadnem souboru nevi.
 *
 * PROC `getComputedStyle` A NE `matchMedia` SAMOTNE
 *
 * Rozhodnout podle `matchMedia('(max-width: 767px)')`, ktery uzel je
 * viditelny, by znamenalo mit zlom zapsany na DVOU mistech (CSS + JS)
 * a verit, ze se nikdy nerozejdou. Modul se proto pta primo na
 * VYSLEDEK kaskady -- `display` uzlu a vsech jeho predku. `matchMedia`
 * zustava jen na to, ktery ZDROJ (mobilni rendition vs. HQ) se ma
 * nasadit, a na udalost `change` jako spoustec prepocitani.
 *
 * MOBILNI RENDITION (`-m.mp4`)
 *
 * `data-src-mobile` nese lehci prepis tehoz banneru (1280x720, ~3 Mbps,
 * bez zvuku), ktery vedle HQ souboru vyrabi samostatna davka. Kdyz pro
 * dany banner na disku NENI, PHP do atributu zapise HQ adresu -- modul
 * tedy nikdy neresi "existuje soubor?", jen "co mi server rekl".
 *
 * PROC INTERSECTIONOBSERVER, KDYZ JE HERO NAHORE
 *
 * Na desktopu je hero prvni obrazovka, takze pozorovatel sepne prakticky
 * okamzite a nic neusetri. Na mobilu ale `.mgal` sedi v `.dhead .wrap`
 * s `order: -1` a pri delsi hlavicce muze byt pod ohybem; a hlavne --
 * az nekdo tuhle komponentu pouzije nize na strance, chovani uz bude
 * spravne bez dalsiho zasahu. `rootMargin: 200px` znamena "zacni, kdyz
 * je 200 px pred viewportem", ne "az kdyz je videt".
 *
 * CO MODUL NIKDY NEDELA: nesaha na `.mgtrack` -- zadny `scrollLeft`,
 * `scrollTo`, `scrollBy`, `scrollIntoView` ani `focus()`. Oprava
 * 54a8a91 (mobilni pas drzi index 0 do prvni interakce) na tom stoji
 * a jakykoli posun pasu odsud by ji tise zrusil.
 *
 * ODMITNUTY `play()`: promise je `.catch()`-ovana a nic dalsiho se
 * nedeje -- stejne jako v `hero.js` (W5). Poster zustava viditelny.
 * Navic se prehrani zkousi znovu na `canplay`, po navratu na zalozku
 * (`visibilitychange`) a po navratu tlacitkem zpet (`pageshow`, bfcache):
 * to jsou tri okamziky, kdy prohlizec autoplay bezne odmitne a pak uz
 * sam od sebe nic nezkusi.
 *
 * BEZPECNOST: zadny `innerHTML`, zadny `eval`, zadna interpolace vstupu.
 * Hodnoty jdou z `data-` atributu (server je vypsal pres `esc_url()`)
 * do `src`/`poster`, tedy do atributu, ktery prohlizec sam validuje.
 */

/** Hranice, pod kterou se pouziva mobilni rendition (tyz zlom jako CSS). */
const MOBILE_QUERY = '(max-width: 767px)';

/**
 * TASK 1277-2b (F4 diagnoza): pod touhle hranici se autoplay VUBEC
 * NENASAZUJE, zustava jen `poster`. NENI TOTEZ jako `MOBILE_QUERY` vys --
 * ten resi jen KTERY SOUBOR (HQ vs `-m.mp4`) se ma pouzit, kdyz uz se
 * neco prehrava; tenhle resi, jestli se ma prehravat VUBEC. 899px je
 * sitovy mobilni zlom projektu (`hp2026.css`, `docs/component-contract-
 * mobile-2026.md`), NE 767px teto komponenty -- schvalne jiny, protoze
 * i sirky 768-899px (kde uz bezi DESKTOPOVA vrstva `.dgvideo`, ne
 * `.mgal`) maji byt bez autoplay (zmereno F4: i lehci `-m.mp4` rendition
 * ma pres 7 MB, samo o sobe nad branou "mobil transfer < 3 MB").
 */
const NO_AUTOPLAY_QUERY = '(max-width: 899px)';

/** Jak daleko pred viewportem se zdroj nasazuje. */
const ROOT_MARGIN = '200px';

/** Cislo z `ROOT_MARGIN` pro rucni dopocet (fallback bez pozorovatele). */
const ROOT_MARGIN_PX = 200;

/**
 * Navesene prvky (`{ el, sync, io }`). Slouzi dvema vecem: hromadnemu
 * prepocitani pri globalni udalosti a UKLIDU po sobe -- `.dgmain` se pri
 * kliku na nahled cely prepise, takze puvodni `<video>` z dokumentu zmizi
 * a jeho pozorovatel i zaznam tady musi zmizet s nim.
 *
 * @type {Array<{el: HTMLVideoElement, sync: Function, io: (IntersectionObserver|null)}>}
 */
const NAVESENE = [];

/** Globalni posluchace (zalozka, bfcache, zmena sirky) se vesi jen jednou. */
let globalniPosluchace = false;

/**
 * Dotaz na mobilni sirku, nebo `null` na prohlizeci bez `matchMedia`.
 *
 * @return {MediaQueryList|null}
 */
function mobilniDotaz() {
	return window.matchMedia ? window.matchMedia(MOBILE_QUERY) : null;
}

/**
 * Dotaz na hranici "zadny autoplay" (TASK 1277-2b), nebo `null` bez
 * `matchMedia`. Fail-open bez `matchMedia`: `zadnyAutoplay()` v tom
 * pripade vrati `false` (autoplay se chova jako dnes) -- prohlizec bez
 * `matchMedia` je i bez `IntersectionObserver` (viz `navesVideo()` nize),
 * tedy uz dnes dostava HQ/desktopove chovani rovnou.
 *
 * @return {MediaQueryList|null}
 */
function zadnyAutoplayDotaz() {
	return window.matchMedia ? window.matchMedia(NO_AUTOPLAY_QUERY) : null;
}

/**
 * Je prvek (nebo kterykoli jeho predek) vypnuty pres `display: none`?
 *
 * Ptat se jen prvku samotneho nestaci: `.mgvideo` ma `display: block`
 * porad, skryva ho az `display: none` na korenu `.mgal` o dve urovne vys.
 *
 * @param {Element} el Prvek.
 * @return {boolean}
 */
function jeSkryty(el) {
	let uzel = el;

	while (uzel && 1 === uzel.nodeType) {
		if ('none' === window.getComputedStyle(uzel).display) {
			return true;
		}

		uzel = uzel.parentElement;
	}

	return false;
}

/**
 * Ktera adresa patri do `src` pri aktualni sirce.
 *
 * @param {HTMLVideoElement} video Prvek videa.
 * @param {MediaQueryList|null} mq Dotaz na mobilni sirku.
 * @return {string} Adresa, nebo prazdny retezec.
 */
function vyberZdroj(video, mq) {
	const mobil = video.getAttribute('data-src-mobile') || '';
	const desktop = video.getAttribute('data-src-desktop') || '';

	if (mq && mq.matches && mobil) {
		return mobil;
	}

	return desktop || mobil;
}

/**
 * Zkusi prehrat. Odmitnuti je bezny provozni stav, ne chyba.
 *
 * @param {HTMLVideoElement} video Prvek videa.
 * @return {void}
 */
function prehraj(video) {
	const spusteno = video.play();

	if (spusteno && 'function' === typeof spusteno.catch) {
		spusteno.catch(function () {
			/* Autoplay zamitnuty prohlizecem -- poster zustava, konzole cista. */
		});
	}
}

/**
 * Nasadi zdroj a rozjede prehravani.
 *
 * Poster se dosazuje PRED `src` ze stejneho duvodu jako v `hero.js`:
 * jinak by prohlizec na okamzik ukazal prazdny cerny box.
 *
 * @param {HTMLVideoElement} video Prvek videa.
 * @param {string} src Adresa souboru.
 * @return {void}
 */
function nasadZdroj(video, src) {
	const poster = video.getAttribute('data-poster');

	if (poster && !video.getAttribute('poster')) {
		video.setAttribute('poster', poster);
	}

	if (video.getAttribute('src')) {
		/* Zmena zdroje za behu -- nejdriv zastavit, at neteces dva buffery. */
		video.pause();
	}

	/*
	 * `autoplay` NENI v markupu a nasazuje se az tady: kdyby v markupu byl,
	 * platil by i pro skrytou variantu a cely smysl opravy by padl.
	 * `muted` uz v markupu je -- bez nej prohlizec autoplay odmita vzdy.
	 */
	video.autoplay = true;
	video.muted = true;
	video.setAttribute('src', src);
	video.load();
	prehraj(video);
}

/**
 * Sunda zdroj ze skryte varianty a vrati prvek do `NETWORK_EMPTY`.
 *
 * Vola se jen tehdy, kdyz uz `src` mel -- typicky po prekroceni hranice
 * 767 px (otoceni telefonu, zmena velikosti okna). Bez tohohle kroku by
 * skryty prvek dal drzel stazeny buffer a pri dalsim prepnuti by se
 * chovani rozeslo s tim, co plati po nacteni stranky.
 *
 * @param {HTMLVideoElement} video Prvek videa.
 * @return {void}
 */
function uvolniZdroj(video) {
	if (!video.getAttribute('src')) {
		return;
	}

	video.pause();
	video.autoplay = false;
	video.removeAttribute('src');
	video.load();
}

/**
 * Je prvek dost blizko viewportu, aby se zdroj vyplatilo nasadit?
 *
 * Rucni dopocet je zaloha pro dva pripady: prohlizec bez
 * `IntersectionObserver` a okamzik hned po prekroceni hranice 767 px,
 * kdy prvek prave prestal byt `display: none` a pozorovatel jeste
 * nestihl ohlasit prvni prusecik.
 *
 * @param {Element} el Prvek.
 * @return {boolean}
 */
function vDosahu(el) {
	const r = el.getBoundingClientRect();

	if (0 === r.width && 0 === r.height) {
		return false;
	}

	return r.top < (window.innerHeight + ROOT_MARGIN_PX) && r.bottom > -ROOT_MARGIN_PX;
}

/**
 * Navesi jeden `<video>`: vyber zdroje, pozorovatel, opakovani `play()`.
 *
 * @param {HTMLVideoElement} video Prvek videa.
 * @param {MediaQueryList|null} mq Dotaz na mobilni sirku.
 * @return {void}
 */
function navesVideo(video, mq, mqNoAutoplay) {
	let vBlizkosti = false;

	/*
	 * BOD 4 (1.27.8): jakmile navstevnik SAM klepne na `.mgplay`
	 * (viz naveseniPlayTlacitka() nize), video uz neni "no-autoplay"
	 * skryta varianta, i kdyz `mqNoAutoplay` porad odpovida sirce pod
	 * 899px. Bez tohohle priznaku by prvni dalsi `sync()` (napr.
	 * `visibilitychange` po navratu na zalozku) zavolal `uvolniZdroj()`
	 * a prehravani prave spustene navstevnikem tise zastavil.
	 */
	let rucneSpusteno = false;

	const sync = function () {
		if (jeSkryty(video)) {
			/* Skryta varianta nesmi drzet ani rozdelany buffer. */
			uvolniZdroj(video);
			vBlizkosti = false;

			return;
		}

		if (!rucneSpusteno && mqNoAutoplay && mqNoAutoplay.matches) {
			/*
			 * TASK 1277-2b: pod 899px se nikdy nenasazuje `src` -- video
			 * zustava `NETWORK_EMPTY`, viditelny je jen `poster` z markupu.
			 * Kdyby uz `src` mel z doby, kdy okno bylo sirsi (zmena
			 * velikosti/otoceni), uvolni ho -- stejna cesta jako skryta
			 * varianta o par radku vys.
			 */
			uvolniZdroj(video);
			vBlizkosti = false;

			return;
		}

		if (!vBlizkosti && !vDosahu(video)) {
			return;
		}

		vBlizkosti = true;

		const src = vyberZdroj(video, mq);

		if (!src) {
			return;
		}

		if (video.getAttribute('src') === src) {
			if (video.paused) {
				prehraj(video);
			}

			return;
		}

		nasadZdroj(video, src);
	};

	let io = null;

	if (window.IntersectionObserver) {
		io = new window.IntersectionObserver(function (zaznamy) {
			let potka = false;

			zaznamy.forEach(function (z) {
				if (z.isIntersecting) {
					potka = true;
				}
			});

			if (potka) {
				vBlizkosti = true;
				sync();
			}
		}, { rootMargin: ROOT_MARGIN });

		io.observe(video);
	} else {
		/*
		 * Bez pozorovatele se rozhoduje hned, ale az v dalsim ticku:
		 * `create()` vraci prvek, ktery volajici teprve vlozi do stromu,
		 * takze merit `display`/rozmery uvnitr teto funkce by bylo mereni
		 * odpojeneho uzlu.
		 */
		window.setTimeout(sync, 0);
	}

	/* Autoplay odmitnuty pri prvnim pokusu -- zkusit znovu, az je co hrat. */
	video.addEventListener('canplay', function () {
		if (video.paused && video.getAttribute('src') && !jeSkryty(video)) {
			prehraj(video);
		}
	});

	/*
	 * BOD 4 (1.27.8, D2 diagnoza nalez A): `.mgplay` je vlastni (ne
	 * YouTube) mobilni video tlacitko play uvnitr `.mgvideo` -- viz
	 * `game-hero-gallery.php`. Klepnuti nasadi `src` (stejny vyber jako
	 * pri autoplay nad 899px), preda ovladani nativnimu `<video
	 * controls>` a schova tlacitko i scrim, at nesedi nad ovladacim
	 * pruhem prohlizece.
	 *
	 * `e.stopPropagation()` JE POVINNE (naleze pri QA 12. 9.): `.mgvideo`
	 * je primy potomek `.mgtrack` a `index.js` (TASK AO DOPLNEK,
	 * `initGameGallery()`) na KAZDE dite `.mgtrack` vesi vlastni
	 * "otevri lightbox" listener. Bez zastaveni probublani by tap na
	 * play SOUCASNE otevrel lightbox a stahl i HQ desktopovou rendition
	 * (`th-*-16x9-*.mp4` bez `-m`) -- zmereno 2 mp4 pozadavky po jednom
	 * tapu misto jednoho, gate "po tapu 1x" by spadl.
	 */
	const mgvideoObal = video.parentElement;
	const mgplayTlacitko = mgvideoObal ? mgvideoObal.querySelector('.mgplay') : null;

	if (mgplayTlacitko) {
		mgplayTlacitko.addEventListener('click', function (e) {
			e.stopPropagation();

			rucneSpusteno = true;

			video.setAttribute('controls', 'controls');
			video.setAttribute('preload', 'metadata');

			const src = vyberZdroj(video, mq);

			if (src) {
				nasadZdroj(video, src);
			}

			mgplayTlacitko.hidden = true;

			const mgscrimVrstva = mgvideoObal.querySelector('.mgscrim');

			if (mgscrimVrstva) {
				mgscrimVrstva.hidden = true;
			}
		});
	}

	NAVESENE.push({ el: video, sync: sync, io: io });
}

/**
 * Prepocita vsechny navesene prvky a uklidi ty, ktere uz nejsou v DOM.
 *
 * @return {void}
 */
function srovnejVse() {
	for (let i = NAVESENE.length - 1; i >= 0; i--) {
		const zaznam = NAVESENE[i];

		if (!document.contains(zaznam.el)) {
			if (zaznam.io) {
				zaznam.io.disconnect();
			}

			NAVESENE.splice(i, 1);

			continue;
		}

		zaznam.sync();
	}
}

/**
 * Navesi globalni posluchace (jednou za zivot stranky).
 *
 * @param {MediaQueryList|null} mq Dotaz na mobilni sirku.
 * @return {void}
 */
function navesGlobalni(mq, mqNoAutoplay) {
	if (globalniPosluchace) {
		return;
	}

	globalniPosluchace = true;

	document.addEventListener('visibilitychange', function () {
		if ('visible' === document.visibilityState) {
			srovnejVse();
		}
	});

	/* Navrat tlacitkem zpet (bfcache) -- prehravani se po obnove nerozjede samo. */
	window.addEventListener('pageshow', function () {
		srovnejVse();
	});

	[mq, mqNoAutoplay].forEach(function (dotaz) {
		if (!dotaz) {
			return;
		}

		if (dotaz.addEventListener) {
			dotaz.addEventListener('change', srovnejVse);
		} else if (dotaz.addListener) {
			/* Safari na spodni hranici matice podpory zna jen starsi API. */
			dotaz.addListener(srovnejVse);
		}
	});
}

/**
 * Postavi hero `<video>` ze stejneho kontraktu jako server a rovnou ho navesi.
 *
 * Pouziva ji `index.js`, kdyz po prohlizeni fotek sklada video dlazdici
 * zpatky do `.dgmain`. Bez teto sdilene cesty by na kliku vznikal
 * `<video autoplay>` se `<source>` -- tedy presne ten tvar, ktery tenhle
 * modul ze serveroveho markupu odstranuje.
 *
 * @param {{srcDesktop: string, srcMobile: (string|undefined), poster: (string|undefined), label: (string|undefined), role: (string|undefined)}} opts Popis videa.
 * @return {HTMLVideoElement|null} Prvek, nebo `null` bez adresy.
 */
function create(opts) {
	if (!opts || !opts.srcDesktop) {
		return null;
	}

	const video = document.createElement('video');

	video.muted = true;
	video.loop = true;
	video.playsInline = true;
	video.setAttribute('muted', 'muted');
	video.setAttribute('loop', 'loop');
	video.setAttribute('playsinline', 'playsinline');
	video.setAttribute('preload', 'none');
	video.setAttribute('data-hero-video', opts.role || 'desktop');
	video.setAttribute('data-src-desktop', opts.srcDesktop);

	if (opts.srcMobile) {
		video.setAttribute('data-src-mobile', opts.srcMobile);
	}

	if (opts.poster) {
		video.setAttribute('data-poster', opts.poster);
		video.setAttribute('poster', opts.poster);
	}

	if (opts.label) {
		video.setAttribute('aria-label', opts.label);
	}

	const mq = mobilniDotaz();
	const mqNoAutoplay = zadnyAutoplayDotaz();

	navesVideo(video, mq, mqNoAutoplay);
	navesGlobalni(mq, mqNoAutoplay);

	return video;
}

/**
 * Vstupni bod modulu.
 *
 * @return {void}
 */
function init() {
	const videa = Array.prototype.slice.call(document.querySelectorAll('video[data-hero-video]'));

	if (0 === videa.length) {
		return;
	}

	const mq = mobilniDotaz();
	const mqNoAutoplay = zadnyAutoplayDotaz();

	videa.forEach(function (video) {
		navesVideo(video, mq, mqNoAutoplay);
	});

	navesGlobalni(mq, mqNoAutoplay);
}

export { init, create };
